export default __webpack_public_path__ + "static/media/youtube_icon_white_1.ef65ea7c.svg";